import React, {useEffect} from 'react';
import {can, translate} from "utils/helpers";
import {useUserContext} from "context/UserContext";
import {Badge, Dropdown} from "antd";
import {BsLock, BsUnlock, IoEllipsisVerticalSharp} from "react-icons/all";
import {Table} from "components/ui";

function UserTable(props) {

    const {
        translateKey,
        permission,
        handleModal,
        dataSource,
        query,
        tableLoading,
        fetchDataSource,
        handleQuery,
        handleAction,
        handleDelete
    } = useUserContext();

    const columns = [
        {
            title: translate(translateKey + '.Label.FullName'),
            dataIndex: 'fullname'
        },
        {
            title: translate(translateKey + '.Label.Email'),
            dataIndex: 'email',
        },
        {
            title: translate(translateKey + '.Label.Permission'),
            dataIndex: 'permission_group',
            render: value => {
                return value?.name || '-'
            }
        },
        {
            title: translate(translateKey + '.Label.Status'),
            dataIndex: 'status',
            width: 50,
            align: 'center',
            render: (value, row) => {
                return <Badge className="badge-status" status={row.is_active ? 'success' : 'error'}/>
            }
        },
        {
            title: translate(translateKey + '.Label.SystemStatus'),
            dataIndex: 'status',
            width: 50,
            align: 'center',
            render: (value, row) => {
                return <div className="flex justify-center">
                    {row.is_block ? <BsLock/> : <BsUnlock/>}
                </div>
            }
        },
    ];

    const actionRender = (row) => {
        const menus = (
            <div className="dropdown dropdown--sm">
                <div className="dropdown-body">
                    <div className="dropdown-items">
                        {can(permission + '.update') && (
                            <button
                                onClick={() => handleModal('form', true, row)}
                                className="dropdown-item h-8"
                            >
                                {translate('button.Edit')}
                            </button>
                        )}
                        {can(permission + '.action') && (
                            <button
                                className="dropdown-item h-8"
                                onClick={() => handleAction(row.id)}
                            >
                                {row.is_active ? translate('button.DeActivate') : translate('button.Activate')}
                            </button>
                        )}
                        {can(permission + '.action') && (
                            <button
                                className="dropdown-item h-8"
                                onClick={() => handleAction(row.id, 'is_block')}
                            >
                                {row.is_block ? translate('button.UserUnBlock') : translate('button.UserBlock')}
                            </button>
                        )}
                        {can(permission + '.delete') && (
                            <button
                                className="dropdown-item h-8"
                                onClick={() => handleDelete(row.id)}
                            >
                                {translate('button.Delete')}
                            </button>
                        )}
                    </div>
                </div>
            </div>
        );
        return <Dropdown overlay={menus} placement={'bottomRight'}>
            <button className="btn btn--action bg-gray-100 text-gray-900 dark:bg-transparent dark:text-gray-300">
                <span>
                    <IoEllipsisVerticalSharp/>
                </span>
            </button>
        </Dropdown>
    }

    useEffect(() => {
        fetchDataSource()
    }, [query])

    return (
        <Table
            tableQuery={query}
            setTableQuery={handleQuery}
            dataSource={dataSource.data}
            total={dataSource.total}
            columns={columns}
            loading={tableLoading}
            sortingStart={1}
            actionWidth={40}
            actionButton={row => actionRender(row)}
        />
    );
}

export default UserTable;
